export default {
  PotenciaNominal: {
    min: 0.001,
    max: 100000000.000,
    label: 'asset-information.cooling-stages.nominal-potency',
    validationLabel: 'asset-information.cooling-stages.validations.nominal-potency',
    precision: 3,
  },
  GradienteTopoOleoAmbiente: {
    min: 0.1,
    max: 100.0,
    label: 'asset-information.cooling-stages.environment-oil-top-gradient',
    validationLabel: 'asset-information.cooling-stages.validations.environment-oil-top-gradient',
    precision: 1,
  },
  GradienteEnrolamentoHOleo: {
    min: 0.1,
    max: 100.0,
    label: 'asset-information.cooling-stages.winding-gradient-h-oil',
    validationLabel: 'asset-information.cooling-stages.validations.winding-gradient-h-oil',
    precision: 1,
  },
  GradienteEnrolamentoXOleo: {
    min: 0.1,
    max: 100.0,
    label: 'asset-information.cooling-stages.winding-gradient-x-oil',
    validationLabel: 'asset-information.cooling-stages.validations.winding-gradient-x-oil',
    precision: 1,
  },
  GradienteEnrolamentoYOleo: {
    min: 0.1,
    max: 100.0,
    label: 'asset-information.cooling-stages.winding-gradient-y-oil',
    validationLabel: 'asset-information.cooling-stages.validations.winding-gradient-y-oil',
    precision: 1,
  },
};
